<template>
    <div :style="`direction:${lang.dir}`">
        <v-form
            ref="crmForInv"
            lazy-validation
        >
        <b-sidebar backdrop lazy width="100rem" id="customer_crm" aria-labelledby="sidebar-no-header-title" no-header :style="`direction:`+lang.ldir" right>
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>{{lang.view_customer}}</span>
                    </div>
                    <div @click="hide" id="HideMeCRM" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="myBtn" :style="`direction:${lang.dir};margin-inline:5px;`" v-if="$store.state.licenseType.activemenu != 'smallif' || $store.state.group_id != 3">
                    <div class="text-center flexMe" style="background:#eee;color:#000;border:1px solid #ccc;padding:5px;">
                        <b-button class="btnsol mytab1 btn btn-sm btn-default m-2"  @click="showAttached()" v-b-toggle.add_gallery :style="`margin-inline:3px;border-radius:5px;padding:5px;background:green !important;color:#fff;`">{{ lang.add_attachment }}</b-button>
                        <b-button class="btnsol mytab1 btn btn-sm btn-default m-2" @click="addQuot()" v-b-toggle.add_quotation :style="`margin-inline:3px;border-radius:5px;padding:5px;background:darkBlue !important;color:#fff;`">{{ lang.add_quotation }}</b-button>
                        <b-button class="btnsol mytab1 btn btn-sm btn-default m-2" @click="viewNotes()" v-b-toggle.add_crmnote :style="`margin-inline:3px;border-radius:5px;padding:5px;background:darkRed !important;color:#fff;`">{{ lang.view_notes }}</b-button>
                        <b-button class="btnsol mytab1 btn btn-sm btn-default m-2" @click="print()" :style="`margin-inline:3px;border-radius:5px;padding:5px;background:green !important;color:#fff;`">{{ lang.print }}</b-button>
                    </div>
                    <v-row>
                        <v-col cols="12" md="6" lg="6" xl="6" class="text-center">
                            <div style="background:#000;color:#FFF;border-radius:5px;padding:5px;">
                                {{ lang.customer_information }}
                            </div>
                            <div style="margin-top: 5px;">
                                <b-table-simple>
                                    <thead>
                                        <tr>
                                            <th class="text-center backBlack">{{ lang.created_date }}</th>
                                            <th class="text-center backBlack">{{ lang.number_of_services }}</th>
                                            <th class="text-center backBlack">{{ lang.deal_status }}</th>
                                            <th class="text-center backBlack">{{ lang.customer_name }}</th>
                                            <th class="text-center backBlack">{{ lang.company_vatid }}</th>
                                            <th class="text-center backBlack">{{ lang.crt_number }}</th>
                                            <th class="text-center backBlack">{{ lang.client_activity }}</th>
                                            <th class="text-center backBlack">{{ lang.client_sub_activity }}</th>
                                            <th class="text-center backBlack">{{ lang.type_of_payments }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">{{ customerDeals.added_date }}</td>
                                            <td class="text-center">{{ customerDeals.service_require.length }}</td>
                                            <td class="text-center" :style="customerDeals.statuses.style">{{ customerDeals.statuses[`name_${lang.langname}`] }}</td>
                                            <td class="text-center">{{ customerDeals.customer_name }}</td>
                                            <td class="text-center">{{ customerDeals.company_vatid }}</td>
                                            <td class="text-center">{{ customerDeals.crt_number }}</td>
                                            <td class="text-center" :style="customerDeals.client_activitys.style">{{ customerDeals.client_activitys[`name_${lang.langname}`] }}</td>
                                            <td class="text-center" :style="customerDeals.client_sub_activitys.style">{{ customerDeals.client_sub_activitys[`name_${lang.langname}`] }}</td>
                                            <td class="text-center" :style="customerDeals.type_of_paymentss.style">{{ customerDeals.type_of_paymentss[`name_${lang.langname}`] }}</td>
                                        </tr>
                                    </tbody>
                                </b-table-simple>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6" class="text-center">
                            <div style="background:#000;color:#FFF;border-radius:5px;padding:5px;">
                                {{ lang.contacts_information }}
                            </div>
                            <div style="margin-top: 5px;">
                                <b-table-simple>
                                    <thead>
                                        <tr>
                                            <th class="text-center backBlack">{{ lang.response_name }}</th>
                                            <th class="text-center backBlack">{{ lang.response_email }}</th>
                                            <th class="text-center backBlack">{{ lang.response_mobile }}</th>
                                            <th class="text-center backBlue" colspan="2" style="width:140px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in customerDeals.response_person" :key="index">
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.response_person[index].response_name" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.response_person[index].response_email" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.response_person[index].response_mobile" /></td>
                                            <td class="text-center backRed" style="width:70px;cursor: pointer;" @click="deleteResp(index)">{{ lang.delete }}</td>
                                            <td class="text-center backBlue" style="width:70px;cursor: pointer;" @click="updateResp(index)">{{ lang.update }}</td>
                                        </tr>
                                    </tbody>
                                </b-table-simple>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6" class="text-center" v-for="(item,index) in customerDeals.service_require" :key="index">
                            <div :style="`border-radius:5px;padding:5px;${getStaticOptions('services_list', item)[`style`]}`">
                                {{ getStaticOptions('services_list', item)[`name_${lang.langname}`] }}
                            </div>
                            <div v-if="item == 1">
                                <b-table-simple>
                                    <thead>
                                        <tr>
                                            <th class="text-center backBlack">{{ lang.type_of_cargo }}</th>
                                            <th class="text-center backBlack">{{ lang.port_of_cargo }} / {{ lang.supplier_address }}</th>
                                            <th class="text-center backBlack">{{ lang.port_of_arrival }}</th>
                                            <th class="text-center backBlue" colspan="2" style="width:140px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(itm,index) in customerDeals.dear_cargo" :key="index">
                                            <td class="text-center"><b-form-select class="selborder" v-model="customerDeals.dear_cargo[index].type_of_cargo" :options="type_of_cargo" /></td>
                                            <td class="text-center" v-if="itm.type_of_cargo !=3 "><b-form-input class="inborder" v-model="customerDeals.dear_cargo[index].port_of_cargo" /></td>
                                            <td class="text-center" v-else><b-form-input class="inborder" v-model="customerDeals.dear_cargo[index].supplier_address" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_cargo[index].port_of_arrival" /></td>
                                            <td class="text-center backRed" style="width:70px;cursor: pointer;" @click="deleteService(item,customerDeals.dear_cargo[index])">{{ lang.delete }}</td>
                                            <td class="text-center backBlue" style="width:70px;cursor: pointer;" @click="UpdateService(item,customerDeals.dear_cargo[index])">{{ lang.update }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="text-center"><b-form-select class="selborder" v-model="cargNew.type_of_cargo" :options="type_of_cargo" /></td>
                                            <td class="text-center" v-if="cargNew.type_of_cargo !=3 "><b-form-input class="inborder" v-model="cargNew.port_of_cargo" /></td>
                                            <td class="text-center" v-else><b-form-input class="inborder" v-model="cargNew.supplier_address" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="cargNew.port_of_arrival" /></td>
                                            <td class="text-center backGreen" colspan="2" style="width:70px;cursor: pointer;" @click="addService(item,cargNew)">{{ lang.add }}</td>
                                        </tr>
                                    </tfoot>
                                </b-table-simple>
                            </div>
                            <div v-if="item == 2">
                                <b-table-simple>
                                    <thead>
                                        <tr>
                                            <th class="text-center backBlack">{{ lang.port_of_arrival }}</th>
                                            <th class="text-center backBlack">{{ lang.number_of_container_monthly }}</th>
                                            <th class="text-center backBlack">{{ lang.number_of_container_by_policy }}</th>
                                            <th class="text-center backBlue" colspan="2" style="width:140px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(itm,index) in customerDeals.dear_customs" :key="index">
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_customs[index].port_of_arrival" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_customs[index].number_of_container_monthly" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_customs[index].number_of_container_by_policy" /></td>
                                            <td class="text-center backRed" style="width:70px;cursor: pointer;" @click="deleteService(item,customerDeals.dear_customs[index])">{{ lang.delete }}</td>
                                            <td class="text-center backBlue" style="width:70px;cursor: pointer;" @click="addService(item,customerDeals.dear_customs[index])">{{ lang.update }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="text-center"><b-form-input class="inborder" v-model="custNew.port_of_arrival" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="custNew.number_of_container_monthly" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="custNew.number_of_container_by_policy" /></td>
                                            <td class="text-center backGreen" colspan="2" style="width:70px;cursor: pointer;" @click="addService(item,custNew)">{{ lang.add }}</td>
                                        </tr>
                                    </tfoot>
                                </b-table-simple>
                            </div>
                            <div v-if="item == 3">
                                <b-table-simple>
                                    <thead>
                                        <tr>
                                            <th class="text-center backBlack">{{ lang.transport_destinations }}</th>
                                            <th class="text-center backBlack">{{ lang.container_number }}</th>
                                            <th class="text-center backBlack">{{ lang.container_type }}</th>
                                            <th class="text-center backBlack">{{ lang.container_weight }}</th>
                                            <th class="text-center backBlack">{{ lang.port_of_arrival }}</th>
                                            <th class="text-center backBlue" colspan="2" style="width:140px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(itm,index) in customerDeals.dear_transport" :key="index">
                                            <td class="text-center"><b-form-select class="selborder" v-model="customerDeals.dear_transport[index].transport_destinations" :options="transport_destinations" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_transport[index].container_number" /></td>
                                            <td class="text-center"><b-form-select class="selborder" v-model="customerDeals.dear_transport[index].container_type" :options="container_type" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_transport[index].container_weight" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="customerDeals.dear_transport[index].port_of_arrival" /></td>
                                            <td class="text-center backRed" style="width:70px;cursor: pointer;" @click="deleteService(item,customerDeals.dear_transport[index])">{{ lang.delete }}</td>
                                            <td class="text-center backBlue" style="width:70px;cursor: pointer;" @click="UpdateService(item,customerDeals.dear_transport[index])">{{ lang.update }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center"><b-form-select class="selborder" v-model="TranspNew.transport_destinations" :options="transport_destinations" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="TranspNew.container_number" /></td>
                                            <td class="text-center"><b-form-select class="selborder" v-model="TranspNew.container_type" :options="container_type" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="TranspNew.container_weight" /></td>
                                            <td class="text-center"><b-form-input class="inborder" v-model="TranspNew.port_of_arrival" /></td>
                                            <td class="text-center backGreen" colspan="2" style="width:70px;cursor: pointer;" @click="addService(item,TranspNew)">{{ lang.add }}</td>
                                        </tr>
                                    </tbody>
                                </b-table-simple>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6" class="text-center">
                            <div :style="`border-radius:5px;padding:5px;background:black;color:#FFF`">
                                {{ lang.quotations }}
                            </div>
                            <b-table-simple>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack">{{ lang.date }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack">{{ lang.vat }}</th>
                                        <th class="text-center backBlack">{{ lang.ftotal }}</th>
                                        <th class="text-center backBlack">{{ lang.status }}</th>
                                        <th class="text-center backBlack">{{ lang.chose_contact_for_print }}</th>
                                        <th class="text-center backBlue" style="width:70px;">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in attach_files" :key="index">
                                        <td class="text-center">{{ item.quot_date }}</td>
                                        <td class="text-center">{{ item.total }}</td>
                                        <td class="text-center">{{ item.vat }}</td>
                                        <td class="text-center">{{ item.ftotal }}</td>
                                        <td class="text-center">{{ item[`status_${lang.langname}`] }}</td>
                                        <td class="text-center"><b-form-select class="selborder" v-model="choseToPrint" :options="Responsed" /></td>
                                        <td class="text-center backRed" style="width:70px;cursor: pointer;" @click="printQuot(item.id)">{{ lang.print }}</td>
                                    </tr>
                                </tbody>
                            </b-table-simple>
                        </v-col>
                    </v-row>

                </div>
                <viewCRMGallery ref="viewCardGall" />
                <addDealCRMNotes ref="addDealCRMNotes" />
                <add-quotation ref="addQuot" :cust='custo'></add-quotation>
            </template>
        </b-sidebar>
        </v-form>
    </div>
</template>


<script>
import axios from 'axios';
import {SnotifyPosition} from 'vue-snotify'
import viewCRMGallery from '@/components/viewCRMGallery.vue'
import AddQuotation from '@/components/addQuotation.vue';
import addDealCRMNotes from '@/components/addDealCRMNotes.vue';
export default {
    components: {viewCRMGallery,AddQuotation,addDealCRMNotes},
    data() {
        return {
            choseToPrint: '',
            custo: {},
            id: 0,
            customerInfo: {},
            customerDeals: [],
            static_options: {},
            cargNew: {
                type_of_cargo: 1,
                port_of_cargo: null,
                supplier_address: null,
                port_of_arrival: null,
            },
            custNew: {
                port_of_arrival: null,
                number_of_container_monthly: null,
                number_of_container_by_policy: null,
            },
            TranspNew: {
                transport_destinations: 1,
                container_number: null,
                container_type: 1,
                container_weight: null,
                port_of_arrival: null,
            },
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        type_of_cargo: function()
        {
            let t = [];
            for(let i = 0; i < this.static_options.type_of_cargo.length; i++) {
                t.push({text: this.static_options.type_of_cargo[i][`name_${this.lang.langname}`], value: this.static_options.type_of_cargo[i].id});
            }
            return t;
        },
        transport_destinations: function()
        {
            let t = [];
            for(let i = 0; i < this.static_options.transport_destinations.length; i++) {
                t.push({text: this.static_options.transport_destinations[i][`name_${this.lang.langname}`], value: this.static_options.transport_destinations[i].id});
            }
            return t;
        },
        container_type: function()
        {
            let t = [];
            for(let i = 0; i < this.static_options.container_types.length; i++) {
                t.push({text: this.static_options.container_types[i][`name_${this.lang.langname}`], value: this.static_options.container_types[i].id});
            }
            return t;
        },
        Responsed: function()
        {
            let t = [];
            for(let i = 0; i < this.customerDeals.response_person.length; i++) {
                t.push({text: this.customerDeals.response_person[i][`response_name`], value: this.customerDeals.response_person[i].response_name});
            }
            return t;
        },
    },
    methods: {
        print()
        {
            window.open('./api/print.php?printCrm='+this.id,'_blank')
        },
        viewNotes() {
            this.$refs.addDealCRMNotes.crmid = this.id;
            this.$refs.addDealCRMNotes.orderid = 0;
            this.$refs.addDealCRMNotes.message = '';
            this.$refs.addDealCRMNotes.status = this.customerDeals.status;
            this.$refs.addDealCRMNotes.statics = this.static_options;
            this.$refs.addDealCRMNotes.getNotes();
        },
        printQuot(id) {
            window.open('./api/print.php?newQuot='+id+'&name='+this.choseToPrint,'_blank')
        },
        addQuot(){
            this.$refs.addQuot.id = 0;
            this.$refs.addQuot.crmid = this.id;
            this.$refs.addQuot.checkUpId = 0;
            this.$refs.addQuot.tbrows = [];
            this.$refs.addQuot.car = {
                    model: '',
                    plate_number: '',
                    color: '',
                    made_year: ''
                }
            this.$refs.addQuot.newrow = {
                    itemcode: '',
                    description: '',
                    item_name: '',
                    qty: 1,
                    item_price: 0,
                    total: 0,
                    vat: 0,
                    ftotal: 0,
                    plate_number: '',
                    discount: 0,
                }
            this.$refs.addQuot.cars = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    brand: '',
                    engine_meter: '',
                    perDisc: 0,
                }]
            this.$refs.addQuot.customer.id=this.customerDeals.customerid;
            this.$refs.addQuot.customer.mobile='';
            this.$refs.addQuot.customer.full_name='';
            this.$refs.addQuot.customer.cctype=2;
            this.$refs.addQuot.company.fullname='';
            this.$refs.addQuot.company.crt_number='';
            this.$refs.addQuot.company.vatid='';

            this.$refs.addQuot.getById();

        },
        showAttached(){
            this.$refs.viewCardGall.card.cardid = this.id;
            this.$refs.viewCardGall.getImages();
        },
        deleteService(item,index){
            const message = this.lang.are_you_sure;
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.agree,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.deleteServ(item,index);
                        }
                    },
                    {
                        text: this.lang.cancel,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
        },
        deleteServ(item,index){
            const post = new FormData();
            post.append("type", "deleteCRMService");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[newInfo]", JSON.stringify(index));
            post.append("data[item]", item);
            post.append("data[customerid]", this.customerDeals.customerid);
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {


                const message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });

                this.getCustomerInfo();
            });
        },
        deleteResp(index){
            const message = this.lang.are_you_sure_delete.replace('{name}', this.customerDeals.response_person[index].response_name);
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.agree,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.deleteAResp(index);
                        }
                    },
                    {
                        text: this.lang.cancel,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
        },
        updateResp(index){
            const post = new FormData();
            post.append("type", "UpdateResponsePerson");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[index]", index);
            post.append("data[customerid]", this.customerDeals.customerid);
            post.append("data[newInfo]", JSON.stringify(this.customerDeals.response_person[index]));
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.getCustomerInfo();
            });
        },
        UpdateService(item,index){
            const post = new FormData();
            post.append("type", "UpdateCRMService");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[newInfo]", JSON.stringify(index));
            post.append("data[item]", item);
            post.append("data[customerid]", this.customerDeals.customerid);
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.getCustomerInfo();
            });
        },
        addService(item,index){
            const post = new FormData();
            post.append("type", "AddCRMService");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[newInfo]", JSON.stringify(index));
            post.append("data[item]", item);
            post.append("data[customerid]", this.customerDeals.customerid);
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                if(item == 1){
                    this.cargNew =  {
                        type_of_cargo: 1,
                        port_of_cargo: '',
                        supplier_address: '',
                        port_of_arrival: '',
                    }
                }
                else if(item == 2){
                    this.custNew =  {
                        port_of_arrival: '',
                        number_of_container_monthly: '',
                        number_of_container_by_policy: '',
                    }
                }
                else if(item == 3){
                    this.TranspNew =  {
                        transport_destinations: 1,
                        container_number: '',
                        container_type: 1,
                        container_weight: '',
                        port_of_arrival: '',
                    }
                }
                this.getCustomerInfo();
            });
        },
        deleteAResp(index)
        {

            const post = new FormData();
            post.append("type", "deleteResponsePerson");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[index]", index);
            post.append("data[customerid]", this.customerDeals.customerid);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {

                const message = this.lang.response_person_deleted.replace('{name}', this.customerDeals.response_person[index].response_name);
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.getCustomerInfo();
            });
        },
        getStaticOptions(phrase, value)
        {
            if(this.static_options[phrase] && this.static_options[phrase].length > 0) {
                for(let i = 0; i < this.static_options[phrase].length; i++) {
                    if(this.static_options[phrase][i].id == value) {
                        return this.static_options[phrase][i];
                    }
                }
            }
        },
        getCustomerInfo()
        {
            const post = new FormData();
            post.append("type", "getClientCRMInfo");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const res = response.data;
                this.customerInfo = res.results.customerInfo;
                this.static_options = res.results.static_options;
                this.attach_files = res.results.attach_files;
                this.customerDeals = res.results.data[0];
                this.choseToPrint = this.customerDeals.response_person[0].response_name ?? '';
            });
        },
        getCheckup()
        {
            return false;
        },

    }
}
</script>
<style>
.flexMe{
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: center;
}
.btnsol{
    width:100px;
}
</style>